exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-new-dialog .modal-dialog{max-width:1140px}", ""]);

// exports
